import React from "react";
import { Chip } from "@material-ui/core";

export function IdentityStatusBadge({ status }) {
  if (status === "verified")
    return <Chip size="small" label="Verified" color="primary" />;

  return <Chip size="small" label="Unverified" />;
}
